module.exports = __webpack_public_path__ + "static/media/promulgation-animation-main-img.8d9e5ab6.jpg";